module.exports = __webpack_public_path__ + "img/7263cef.jpg";